import React from 'react';
import styles from './RandRDashboardTable.module.scss';

import { TableWrapper } from 'components/SummaryComponents';
import { StyledTableCell, StyledTableRow } from 'components/StyledComponents';
import StyledLink from 'components/StyledLink';

import { Table, TableHead, TableBody } from '@material-ui/core';

import { useUserConfig } from 'hooks/useUserConfig';

import NoDataView from '../../NoDataView';

import { generateCellUrl } from '../../../helpers';

const COLUMNS = ['Capacity', 'On Roster', 'On Site', 'Available'];

export default function RandRDashboardTable({ data }) {
  const { capacities, total } = data;

  const { isAdminUser, isPersonnelManagerUser } = useUserConfig();

  if (!capacities?.length && data?.department?.id)
    return <NoDataView label="No matches in the table." />;

  if (!capacities?.length && !data?.department?.id)
    return <NoDataView label="Set filter data to generate R&R Dash." />;

  const generateUrlParams = (capacityId, dashboardField) => ({
    dashboardId: data.id,
    dashboardType: 'RandRDashboard',
    dashboardField,
    capacityId
  });

  const shouldAllowRedirect = (value = 0) => (isAdminUser || isPersonnelManagerUser) && value > 0;

  return (
    <div className={styles.table}>
      <TableWrapper>
        <Table>
          <TableHead>
            <StyledTableRow>
              {COLUMNS.map((name, index) => (
                <StyledTableCell key={index}>{name}</StyledTableCell>
              ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {capacities.map(({ capacity, randRInfo }, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell className={styles.capacityCell}>
                  {capacity?.name || ''}
                </StyledTableCell>
                <StyledTableCell className={styles.onRosterCell}>
                  <StyledLink
                    to={generateCellUrl(generateUrlParams(capacity.id, 'OnRoster'))}
                    isRedirectAvailable={shouldAllowRedirect(randRInfo?.onRoster)}>
                    {randRInfo?.onRoster || 0}
                  </StyledLink>
                </StyledTableCell>
                <StyledTableCell className={styles.onSiteCell}>
                  <StyledLink
                    to={generateCellUrl(generateUrlParams(capacity.id, 'OnSite'))}
                    isRedirectAvailable={shouldAllowRedirect(randRInfo?.onSite)}>
                    {randRInfo?.onSite || 0}
                  </StyledLink>
                </StyledTableCell>
                <StyledTableCell className={styles.availableCell}>
                  <StyledLink
                    to={generateCellUrl(generateUrlParams(capacity.id, 'available'))}
                    isRedirectAvailable={shouldAllowRedirect(randRInfo?.available)}>
                    {randRInfo?.available || 0}
                  </StyledLink>
                </StyledTableCell>
              </StyledTableRow>
            ))}
            <StyledTableRow className={styles.total}>
              <StyledTableCell>TOTAL</StyledTableCell>
              <StyledTableCell>{total?.onRoster || 0}</StyledTableCell>
              <StyledTableCell>{total?.onSite || 0}</StyledTableCell>
              <StyledTableCell>{total?.available || 0}</StyledTableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableWrapper>
    </div>
  );
}
